<template>
  <qx-card-form title="基础信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <section slot="acc" slot-scope="prop">
        <ChooseBankcard
          :type="$route.query.type"
          :isRadio="true"
          v-model="prop.form.acc"
          @change="handleAccChange"
          :otherSearchData="{
            userId: userInfo.staffTFInfo.userId,
          }"
        />
      </section>
      <section slot="transferAmount" slot-scope="prop">
        {{prop.form.transferAmount}}
      </section>
      <!-- 支付密码 -->
      <section slot="payPasswd" slot-scope="prop">
        <el-input
          type="password"
          class="inputBox"
          v-model="prop.form.payPasswd"
          placeholder="请输入密码"
        >
          <span class="primary cur inputSlotText" slot="suffix" @click="toForgetPayPsw">
            忘记支付密码
          </span>
        </el-input>
      </section>
      <!-- 支付密码 end -->
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import ChooseBankcard from 'components/choose/bankcard';
import {
  mapState,
} from 'vuex';
export default {
  components: {
    ChooseBankcard,
  },
  data () {
    return {
      baseForm: {
        form: [
          {
            label: '账户名称',
            value: 'acc',
            default: {},
            slot: true,
          },
          {
            label: '转出账户',
            value: 'accountType',
            type: 'radio',
            default: 1,
            options: [
              {
                label: '收款账户(公户)',
                value: 1,
              },
              {
                label: '付款账户(公户)',
                value: 2,
              },
            ],
          },
          {
            label: '可提现金额',
            value: 'transferAmount',
            slot: true,
            hide: true,
          },
          {
            label: '提现金额',
            value: 'amount',
            type: 'input',
          },
          {
            label: '支付密码',
            value: 'payPasswd',
            slot: true,
          },
        ],
        rules: {
          acc: [ // 账户名称
            { required: true, message: '请选择账户', trigger: 'blur' },
          ],
          amount: [ // 提现金额
            { required: true, message: '请输入提现金额', trigger: 'blur' },
          ],
          payPasswd: [ // 支付密码
            { required: true, message: '请输入支付密码', trigger: 'blur' },
          ],
        },
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {
    toForgetPayPsw () {
      this.jump({
        label: '忘记支付密码',
        url: '/manage/other/forgetPayPsw',
      });
    },
    handleAccChange () {
      const acc = this.$refs.baseForm.getVal('acc');
      this.$refs.baseForm.setVal('transferAmount', acc.bankBalance);
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: false,
        names: ['transferAmount'],
      });
    },
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        formData.accId = formData.acc.accId;
        formData.custName = formData.acc.custName;
        formData.payAcctId = formData.acc.payAcctId;
        formData.receAcctId = formData.acc.receAcctId;
        delete formData.acc;
      }
      return formData;
    },

    async sub () {
      const formData = await this.handleSubData();
      if (formData) {
        formData.payPasswd = this.encode(formData.payPasswd);
        if (formData.type === 1) { // 收款
          formData.accId = formData.receAcctId;
        } else { // 付款
          formData.accId = formData.payAcctId;
        }
        delete formData.receAcctId;
        delete formData.payAcctId;
      }
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    async init (data = {}) {
      if (data.accId) {
        data.acc = {
          accId: data.accId,
          custName: data.custName,
          payAcctId: data.payAcctId,
          receAcctId: data.receAcctId,
        };
      } else {
        data.acc = {};
      }
      if (!data.accountType) {
        data.accountType = 1;
      }
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>

<style scoped lang="scss">
.getCodeBtn{
  padding-right: 8px;
}
</style>
